(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hac-home-video"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hac-home-film')){
  customElements.define('hac-home-film',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      const video=this.querySelector('video'),button=this.querySelector('button');
      if(!video||!button)return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      button.hidden=false;
      video.controls=true;
      button.addEventListener('click',()=>{
        button.hidden=true;
        video.controls=true;
        const playback=video.play();
        if(playback&&typeof playback.catch==='function'){
          playback.catch(()=>{button.hidden=true;video.controls=true;});
        }
      },options);
      video.addEventListener('play',()=>{button.hidden=true;},options);
      video.addEventListener('ended',()=>{button.hidden=false;},options);
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
}
  } catch(e) { console.error(e); }
})();

})();
